import makeRequest from './index';

export function Subscription(requestBody) {
    return makeRequest({
        uri: '/v1/subscribers',
        method: 'POST',
        body: JSON.stringify(requestBody)
    });
}
